import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBuilding,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons";
import { handleErrors } from "../utils/errorHandler";
import {
  getAllpropertyNameUrl,
  getAllBlogSNameAndUrl,
} from "../services/siteMapService";
export default function RentSiteMap() {
  const [propertyData, setPropertyData] = useState([]);
  const [blogsData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(false);

  //get the all the Data
  useEffect(() => {
    const getAllData = async () => {
      setLoading(true);
      try {
        const [propertyResponse, blogResponse] = await Promise.all([
          getAllpropertyNameUrl(),
          getAllBlogSNameAndUrl(),
        ]);

        setPropertyData(propertyResponse?.data?.result || []);
        setBlogData(blogResponse?.data?.result || []);
      } catch (error) {
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    };
    getAllData();
  }, []);
  return (
    <section className="Rent-siteMap">
      <Container>
        <Row>
          <Col md={12} className="text-center">
            <h1 className="text-center">SiteMap</h1>
            <p>
              <FontAwesomeIcon icon={faHome} className="icon" /> Werentt
              Site-Map Link
            </p>
          </Col>
          <Col md={12}>
            <ul className="Web-page-urls">
              <li>
                <Link to={"/"}>Home</Link>
              </li>
              <li>
                <Link to={"/about-us"}>About Us</Link>
              </li>
              <li>
                <Link to={"/faq"}>FAQ</Link>
              </li>
              <li>
                <Link to={"/contact-us"}>Contact Us</Link>
              </li>
              <li>
                <Link to={"/list-your-property"}>List your Property</Link>
              </li>
              <li>
                <Link to={"/terms-conditions  "}>Terms And Condition</Link>
              </li>
              <li>
                <Link to={"/privacy-policy"}>Privacy Policy</Link>
              </li>
              <li>
                <Link to={"/cancellation-policy"}>Cancelation Ploicy</Link>
              </li>
            </ul>
          </Col>
          <Col md={12}>
            <h2 className="site-map title-2">
              <FontAwesomeIcon icon={faBuilding} className="icon" /> Rental
              Properties
            </h2>

            <ul className="property-name-url">
              {propertyData.length > 0
                ? propertyData.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={`/property/${item.flatUrl}-${item.id}`}
                        target="_blank"
                      >
                        {item.flatDisplayName}-{`(${item.id})`}
                      </Link>
                    </li>
                  ))
                : "-"}
            </ul>
          </Col>
          <Col md={12} className="mt-3">
            <h2 className="site-map title-2">
              <FontAwesomeIcon icon={faNewspaper} className="icon" /> Blogs
            </h2>

            <ul className="property-name-url">
              {blogsData.length > 0
                ? blogsData.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={`/blogs/${item.blogUrl}-${item.id}`}
                        target="_blank"
                      >
                        {item.blogName}
                      </Link>
                    </li>
                  ))
                : "-"}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
